export default __webpack_public_path__ + "static/media/db.9294d125.svg";